export default __webpack_public_path__ + "static/media/screens.ece60285.png";